/*******************************************************************************
SHOW SUB PAGES
Shows the sub pages for the tab that was clicked on.
*******************************************************************************/

export default function showSubPages(tabName) {
    const $subPagesContainer = $(`.l-boxes[data-name="${tabName}"]`);
    const $connectedTab = $(`.scroll-tab[data-name="${tabName}"]`);

    // Switch the selected tab to the one that was clicked
    $connectedTab.siblings('.scroll-tab').removeClass('is-selected hovering').end().addClass('is-selected');

    // Make sure all the other tabs are "closed"
    $connectedTab.siblings('.scroll-tab.has-more').removeClass('is-open').addClass('is-closed');

    // Hide all sub page sections and toggle the selected tab's sub-section
    $subPagesContainer.siblings('.l-boxes').addClass('hide');
    $subPagesContainer.toggleClass('hide');

    // If the selected tab was closed, scroll to the tab and open it
    if ($connectedTab.hasClass('is-closed')) {
        // $('html, body').animate({ scrollTop: $connectedTab.offset().top }, 300); -- killed by Herb
        $connectedTab.addClass('is-open').removeClass('is-closed');
    }

    // If the selected tab was open:
    // 1. Close it
    // 2. Restore the selected tab to it's initial state (whichever page was originally selected on page load)
    else {
        $connectedTab.addClass('is-closed').removeClass('is-open is-selected');
        $connectedTab.parents().find('.was-selected').addClass('is-selected');
    }
}
